/* @flow */

import React, { useEffect, useContext } from "react";
import useCookie from "helpers/hooks/use-cookie";
import { useLocation } from "react-router";
import { parseParams } from "helpers/location-search-string";
import { StoreInfoContext } from "entrypoint/shared";

const useShowPrices = (watchUrl: boolean = false): {
  showPrices: boolean,
  setShowPrices: (value: string) => void,
  showPricesRead: boolean,
} => {
  const secret = "medlem789986";
  const location = useLocation();
  const { info: { pricelock } } = useContext(StoreInfoContext);
  const { pl } = parseParams(location.search);
  const cookieOpts = { expires: 365 };
  const [showPrices, setShowPrices, showPricesRead] = useCookie("show-prices", "", cookieOpts);

  useEffect(() => {
    if (pl === secret && watchUrl === true && showPrices !== "true") {
      setShowPrices("true");
    }
  }, [location]);

  return { showPrices: showPrices === "true" || pricelock === false, setShowPrices, showPricesRead };
};

export default useShowPrices;
